
import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Twitter, Instagram, Github, Heart } from 'lucide-react';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="w-full bg-[#0a0a0a] border-t border-white/5 pt-12 pb-8 mt-auto z-10 relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
                    {/* Brand Column */}
                    <div className="space-y-4">
                        <Link to="/" className="flex items-center space-x-3 group">
                            <div className="relative flex items-center overflow-hidden rounded-xl">
                                <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-cyan-400 opacity-30 blur-md" />
                                <img src="/favicon_new.png" className="relative z-10 w-7 h-7 top-1" alt="ComicMenia" />
                            </div>
                            <span className="text-xl font-bold bg-gradient-to-r from-purple-400 via-violet-400 to-cyan-400 bg-clip-text text-transparent">
                                ComicMenia
                            </span>
                        </Link>
                        <p className="text-gray-400 text-sm leading-relaxed">
                            The next-generation platform for digital comics. Create, share, and support independent creators.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Platform</h3>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li><Link to="/" className="hover:text-purple-400 transition-colors">Home</Link></li>
                            <li><Link to="/community" className="hover:text-purple-400 transition-colors">Community</Link></li>
                            <li><Link to="/create-comic" className="hover:text-purple-400 transition-colors">Start Creating</Link></li>
                            <li><Link to="/credits" className="hover:text-purple-400 transition-colors">Get Credits</Link></li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Legal</h3>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li><Link to="/privacy" className="hover:text-purple-400 transition-colors">Privacy Policy</Link></li>
                            <li><Link to="/contact" className="hover:text-purple-400 transition-colors">Contact Us</Link></li>
                            <li><Link to="/terms" className="hover:text-purple-400 transition-colors">Terms of Service</Link></li>
                            <li><Link to="/content-policy" className="hover:text-purple-400 transition-colors">Content Guidelines</Link></li>
                        </ul>
                    </div>

                    {/* Social */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Connect</h3>
                        <div className="flex space-x-4">
                            <span className="p-2 rounded-full bg-white/5 text-gray-600 opacity-30 cursor-not-allowed" title="Coming Soon">
                                <Twitter className="w-5 h-5" />
                            </span>
                            <a href="https://www.instagram.com/comicmenia/" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/5 hover:bg-pink-600/20 text-gray-400 hover:text-pink-400 transition-all">
                                <Instagram className="w-5 h-5" />
                            </a>
                            <span className="p-2 rounded-full bg-white/5 text-gray-600 opacity-30 cursor-not-allowed" title="Coming Soon">
                                <Github className="w-5 h-5" />
                            </span>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
                    <p>&copy; {currentYear} ComicMenia. All rights reserved.</p>
                    <div className="flex items-center mt-4 md:mt-0">
                        <span>Made with</span>
                        <Heart className="w-4 h-4 mx-1.5 text-red-500 fill-red-500/20 animate-pulse" />
                        <span>for creators</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
